import { IconMap16 } from '@warp-ds/icons/react';
import { Button } from '@warp-ds/react';
import { useRouter } from 'next/router';
import { SortDetails } from 'shared/page/SortDetails';
import type { AutocompleteData, Filters } from '@/domain';
import { FilterButton } from '@/scenes/resultPage/components/filters/FilterButton';
import { SaveSearch } from '@/scenes/resultPage/components/saveSearch/SaveSearch';
import { parseUrl } from '@/scenes/resultPage/helpers';
import { Sorting } from '../sorting/Sorting';

type TopBarProps = {
    onFilterChanged: (filters: Filters) => void;
    filters: Filters;
    filterData: Record<string, unknown>;
    autocompleteData: AutocompleteData;
    isLoggedIn: boolean;
};

export const TopBar = ({ onFilterChanged, filters, filterData, autocompleteData, isLoggedIn }: TopBarProps) => {
    const router = useRouter();
    const searchParams = parseUrl(router.query);

    return (
        <div className="flex flex-row flex-wrap pb-16 justify-between gap-y-16" data-testid="topBar">
            <FilterButton
                filters={filters}
                filterData={filterData}
                onFilterChanged={onFilterChanged}
                className="flex gap-4 md:hidden min-w-8"
            />
            <Button small utility href={`${router.basePath}/kart/?${searchParams.toString()}`} className="flex gap-4 md:hidden min-w-8">
                <IconMap16 aria-hidden />
                Kart
            </Button>
            <SaveSearch filters={filters} autocompleteData={autocompleteData} isLoggedIn={isLoggedIn} data-testid="save-search-box" />
            <Sorting filters={filters} onFilterChanged={onFilterChanged} />
            <SortDetails section="feriehus" className="flex md:order-1 min-w-8 md:ml-[64]" />
        </div>
    );
};
